import React, { useEffect, useState, useRef } from "react";
import {
  useUpdateUserReadingAnswers,
  useGetReading,
  useGetReadingPassage,
} from "../../services";
import QuestionSet from "../common/QuestionSet";
import Loading from "../layout/Loading";
import TopBar from "../layout/TopBar";
import NavigationBar from "../navigation-bar";
import ResizableDivider from "../common/ResizableDivider"; // Updated import
import TextHighlighter from "../../utils/textHighlighter";
import Header from "../layout/Header";
import { useExamServerDataOperations } from "../../hooks/useExamServerDataOperations";

const Reading = () => {
  const { reading } = useGetReading();
  const { readingPassage, isLoadingReadingTest, errorReadingTest } =
    useGetReadingPassage();

  useExamServerDataOperations();
  const updateBulkData = useUpdateUserReadingAnswers();

  // Store left section width in percentage
  const [leftWidth, setLeftWidth] = useState(50);
  const containerRef = useRef(null);

  if (isLoadingReadingTest) return <Loading />;
  if (errorReadingTest) return <div>{errorReadingTest}</div>;

  const passageArticle = readingPassage?.article || "";

  return (
    <section className="h-screen">
      <Header />

      <div className="p-3 h-[calc(100vh-116px)]">
        <TopBar
          section="reading"
          unit={readingPassage.passageNum}
          instruction={readingPassage.instructionLabel}
        />
        <div
          className="flex p-2"
          ref={containerRef}
          style={{ display: "flex", width: "100%" }}
        >
          <div
            className="reading-section"
            style={{
              flexBasis: `${leftWidth}%`,
              transition: "width 0.1s ease",
            }}
          >
            <div className="passageArticle">
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  fontFamily: "Arial",
                  margin: 0,
                  padding: 0,
                }}
              >
                <TextHighlighter
                  html={`<div data-block-id="passage-${readingPassage.passageNum}">${passageArticle}</div>`}
                  docId={"stage-" + readingPassage.passageNum}
                />
              </div>
            </div>
          </div>

          <ResizableDivider
            containerRef={containerRef}
            leftWidth={leftWidth}
            onWidthChange={setLeftWidth}
          />

          <div
            className="questions-section"
            style={{
              flexBasis: `${100 - leftWidth}%`,
              transition: "width 0.1s ease",
            }}
          >
            <TextHighlighter
              docId={"stage-" + readingPassage.passageNum + "-questions"}
            >
              <div data-block-id={"question-" + readingPassage.passageNum}>
                {readingPassage?.questionSets?.map((set, index) => (
                  <QuestionSet key={index} index={index} set={set} />
                ))}
              </div>
            </TextHighlighter>
          </div>
        </div>
      </div>

      <NavigationBar
        sectionData={reading}
        section="reading"
        stageQuestionInterval={readingPassage.totalQuestionInterval}
        updateBulkData={updateBulkData}
      />
    </section>
  );
};
export default Reading;
